<template>
  <div class="page--heading">
    <h1>{{ $route.meta.title }}</h1>
    <div class="stat-buttons" v-if="$route.name === 'feeds'">
      <router-link class="btn btn-blue" to="/create-feed">
        <svg class="svg-sprite-icon svg-sprite-unstyled icon-plus">
          <use xlink:href="@/assets/img/svg/symbol/symbol_unstyled.svg#plus"></use>
        </svg>
        Создать фид
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentHeader'
}
</script>
